import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.html';
import '../src/views/_css/app.scss';
import '../src/views/_css/skin.scss';
import { UrlState, AppConfig } from '@luxms/bi-core';
import jQuery from 'jquery';
import moment from 'moment';

// Жыве жыкюэрий
(window as any).$ = jQuery;
(window as any).jQuery = jQuery;

// Хай буде момент
(window as any).moment = moment;

// logo
// console.log('\n\n %c %c %c %c %c Luxms BI \n',
//             'background: #E07921;margin: 0 2px;padding:0px 0 6px 0; border-radius: 5px;',
//             'background: #4AB6E8; margin: 0 2px;padding:7px 0 6px 0; border-radius: 5px;',
//             'background: #4F4F9B; margin: 0 2px;padding:15px 0 6px 0; border-radius: 5px;',
//             'background: #AA6FAC; margin: 0 2px;padding:20px 0 6px 0; border-radius: 5px;',
//             'background: transparent; color: #F05045; padding:5px 0; font-weight: bold; font-size:200%;');
//
console.log(
  '%c %c Luxms BI',
  `padding-left:64px;display:inline-block;padding-top:54px;height:64px;background-repeat:no-repeat;background-image:url("data:image/svg+xml,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20%20%20%20%20xml%3Aspace%3D'preserve'%20%20%20%20%20width%3D'64'%20height%3D'64'%20%20%20%20%20version%3D'1.1'%20%20%20%20%20viewBox%3D'0%200%20360%20360'%3E%20%20%3Cstyle%20type%3D'text%2Fcss'%3E%3C!%5BCDATA%5B%20%20%20%20.Preloader__Col1%20%7B%20fill%3A%20%23E07921%3B%20%20%7D%20%20%20%20.Preloader__Col2%20%7B%20fill%3A%20%234AB6E8%3B%20animation%3A%20Preloader__Col2__Animate%206s%202.6s%20infinite%20ease-in-out%3B%20%20%20%20%20%20transform-origin%3A%2010%25%2080%25%3B%20%20%20%20%7D%20%20%20%20.Preloader__Col3%20%7B%20fill%3A%20%234F4F9B%3B%20animation%3A%20Preloader__Col4__Animate%2010s%20infinite%3B%20%20%20%20%20%20transform-origin%3A%2011.4%25%2044%25%3B%20%20%20%20%7D%20%20%20%20.Preloader__Col4%20%7B%20fill%3A%20%23AA6FAC%3B%20%20%7D%20%20%20%20%40keyframes%20Preloader__Col2__Animate%20%7B%20%20%20%20%20%200%25%20%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%20%20%20%7D%20%20%20%20%20%2033%25%20%20%7B%20transform%3A%20scale(1%2C%201.2)%3B%20%7D%20%20%20%20%20%2066%25%20%20%7B%20transform%3A%20scale(1%2C%200.8)%3B%20%7D%20%20%20%20%20%20100%25%20%7B%20transform%3A%20scale(1)%3B%20%20%20%20%20%20%7D%20%20%20%20%7D%20%20%20%20%40keyframes%20Preloader__Col4__Animate%7B%20%20%20%20%20%200%25%20%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%20%20%20%7D%20%20%20%20%20%2033%25%20%20%7B%20transform%3A%20scale(1%2C%200.8)%3B%20%7D%20%20%20%20%20%2050%25%20%20%7B%20transform%3A%20scale(1%2C%201.1)%3B%20%7D%20%20%20%20%20%20100%25%20%7B%20transform%3A%20scale(1)%3B%20%20%20%20%20%20%7D%20%20%20%20%7D%20%20%20%20.Preloader__Sector%20%7B%20%20%20%20%20%20animation%3A%20Preloader__Sector%2010s%20infinite%3B%20%20%20%20%7D%20%20%20%20.Preloader__Sector2%20%7B%20%20%20%20%20%20fill%3A%20%235FB138%3B%20%20%20%20%20%20animation%3A%20Preloader__Sector2__Animate%2010s%20infinite%3B%20%20%20%20%7D%20%20%20%20.Preloader__Sector3%20%7B%20%20%20%20%20%20fill%3A%20%23F05045%3B%20%20%20%20%20%20animation%3A%20Preloader__Sector3__Animate%2010s%20infinite%3B%20%20%20%20%7D%20%20%20%20.Preloader__Sector4%20%7B%20%20%20%20%20%20fill%3A%20%23E85498%3B%20%20%20%20%20%20animation%3A%20Preloader__Sector4__Animate%2010s%20infinite%3B%20%20%20%20%7D%20%20%20%20.Preloader__Sector%2C%20.Preloader__Sector2%2C%20.Preloader__Sector3%2C%20.Preloader__Sector4%20%7B%20transform-origin%3A%20235.55px%20258.95px%3B%20%7D%20%20%20%20%40keyframes%20Preloader__Sector%20%7B%20%20%20%20%20%200%25%20%20%20%7B%20transform%3A%20rotate(%2020deg)%3B%20%7D%20%20%20%20%20%2017%25%20%20%7B%20transform%3A%20rotate(210deg)%3B%20%7D%20%20%20%20%20%2033%25%20%20%7B%20transform%3A%20rotate(210deg)%3B%20%7D%20%20%20%20%20%2045%25%20%20%7B%20transform%3A%20rotate(320deg)%3B%20%7D%20%20%20%20%20%2066%25%20%20%7B%20transform%3A%20rotate(320deg)%3B%20%7D%20%20%20%20%20%2075%25%20%20%7B%20transform%3A%20rotate(380deg)%3B%20%7D%20%20%20%20%20%20100%25%20%7B%20transform%3A%20rotate(380deg)%3B%20%7D%20%20%20%20%7D%20%20%20%20%40keyframes%20Preloader__Sector3__Animate%7B%20%20%20%20%20%200%25%20%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2015%25%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2027%25%20%20%7B%20transform%3A%20scale(1.1)%3B%20%7D%20%20%20%20%20%2037%25%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2066%25%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2080%25%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%20100%25%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%7D%20%20%20%20%40keyframes%20Preloader__Sector4__Animate%7B%20%20%20%20%20%200%25%20%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2045%25%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2055%25%20%20%7B%20transform%3A%20scale(1.1)%3B%20%7D%20%20%20%20%20%2066%25%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2080%25%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%20100%25%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%7D%20%20%20%20%40keyframes%20Preloader__Sector2__Animate%7B%20%20%20%20%20%200%25%20%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2011%25%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2044%25%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2073%25%20%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%20%2085%25%20%20%7B%20transform%3A%20scale(1.1)%3B%20%7D%20%20%20%20%20%20100%25%20%7B%20transform%3A%20scale(1)%3B%20%20%20%7D%20%20%20%20%7D%20%20%5D%5D%3E%20%20%3C%2Fstyle%3E%20%20%3Cg%20id%3D'Preloader'%3E%20%20%20%20%3Cg%20class%3D'Preloader__Col'%3E%20%20%20%20%20%20%3Cpath%20class%3D'Preloader__Col1'%20d%3D'M22%20180l-0%200c-12%2C0%20-22%2C10%20-22%2C22l0%2056c0%2C12%2010%2C22%2022%2C22l0%200c12%2C0%2022%2C-10%2022%2C-22l0%20-56c0%2C-12%20-10%2C-22%20-22%2C-22z'%2F%3E%20%20%20%20%20%20%3Cpath%20class%3D'Preloader__Col2'%20d%3D'M97%20100l-0%200c-12%2C0%20-22%2C10%20-22%2C22l0%20132c0%2C12%2010%2C22%2022%2C22l0%200c12%2C0%2022%2C-10%2022%2C-22l0%20-132c0%2C-12%20-10%2C-22%20-22%2C-22z'%2F%3E%20%20%20%20%20%20%3Cpath%20class%3D'Preloader__Col3'%20d%3D'M172%2039l0%200c-12%2C0%20-22%2C10%20-22%2C22%200%2C41%200%2C83%200%2C124%20-0%2C1%20-0%2C8%200%2C8%201%2C0%204%2C-5%205%2C-5%201%2C-2%203%2C-3%204%2C-5%2010%2C-10%2020%2C-17%2032%2C-22%203%2C-1%203%2C-2%203%2C-5%20-0%2C-15%20-0%2C-30%20-0%2C-46%200%2C-17%200%2C-33%200%2C-50%200%2C-12%20-10%2C-22%20-22%2C-21z'%2F%3E%20%20%20%20%20%20%3Cpath%20class%3D'Preloader__Col4'%20d%3D'M248%200l0%200c-12%2C0%20-22%2C10%20-22%2C22%200%2C41%200%2C81%20-0%2C122%20-0%2C1%20-0%2C6%200%2C7%201%2C1%206%2C0%208%2C0%2011%2C-0%2022%2C1%2033%2C5%204%2C1%204%2C1%204%2C-3%20-0%2C-9%20-0%2C-19%20-0%2C-28%200%2C-34%200%2C-68%200%2C-102%200%2C-12%20-10%2C-22%20-22%2C-23z'%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%20class%3D'Preloader__Sector'%3E%20%20%20%20%20%20%3Cpath%20class%3D'Preloader__Sector2'%20d%3D'M318%20242c1%2C-0%206%2C-0%207%2C-1%201%2C-2%20-4%2C-16%20-5%2C-19%20-5%2C-12%20-13%2C-23%20-23%2C-32%20-14%2C-12%20-29%2C-19%20-46%2C-22%20-2%2C-0%20-6%2C-2%20-7%2C0%20-1%2C1%20-0%2C7%20-0%2C9%200%2C21%200%2C43%20-0%2C64%20-0%2C1%20-0%2C7%201%2C7%201%2C1%206%2C-0%208%2C-0%2022%2C-2%2044%2C-5%2066%2C-6z'%2F%3E%20%20%20%20%20%20%3Cpath%20class%3D'Preloader__Sector3'%20d%3D'M222%20284c2%2C-8%204%2C-16%205%2C-24%201%2C-4%200%2C-7%200%2C-11%20-0%2C-24%20-0%2C-49%200%2C-73%200%2C-2%201%2C-7%20-1%2C-8%20-1%2C-1%20-7%2C0%20-9%2C1%20-18%2C4%20-34%2C12%20-47%2C25%20-17%2C17%20-27%2C39%20-27%2C65%200%2C22%208%2C42%2020%2C58%2011%2C13%2025%2C23%2041%2C29%204%2C2%204%2C-0%205%2C-4%201%2C-7%203%2C-14%204%2C-21%202%2C-10%204%2C-21%207%2C-31%200%2C-2%201%2C-3%201%2C-5z'%2F%3E%20%20%20%20%20%20%3Cpath%20class%3D'Preloader__Sector4'%20d%3D'M246%20266c-4%2C0%20-4%2C2%20-5%2C6%20-1%2C7%20-3%2C14%20-4%2C20%20-2%2C7%20-3%2C14%20-4%2C21%20-1%2C4%20-2%2C7%20-2%2C10%20-2%2C8%20-3%2C16%20-5%2C23%20-1%2C3%20-0%2C3%203%2C4%203%2C0%205%2C0%208%2C0%2025%2C0%2048%2C-10%2065%2C-27%2017%2C-17%2027%2C-40%2027%2C-64%200%2C-2%20-0%2C-2%20-3%2C-2%20-7%2C1%20-14%2C2%20-21%2C2%20-19%2C2%20-39%2C4%20-52%20%20%2C6z'%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E")`,
  'background: transparent; color: #F05045; padding:5px 0; font-weight: bold; font-size:250%;');


// TODO: remove (moved to ThemeVC)

(window as any).applyTheme = (theme: string) => {
  (window as any).__themeVC.setTheme(theme);
};

(window as any).toggleTheme = () => {
  let theme = document.body.className.match(/theme-(\w+)/) ? RegExp.$1 : 'light';
  if (theme === 'light') theme = 'dark';
  else theme = 'light';
  (window as any).applyTheme(theme);
};


// $(document).on('mousedown', 'button.material, a.material, .button.material', function (e) {
//   var target = e.target;
//   if (!$(target).hasClass('material')) {
//     target = $(target).closest('.material')[0];
//   }
//   if (!target) return false;
//   var rect = target.getBoundingClientRect();
//   // var ripple: any = target.querySelector('.ripple');
//   var ripple: any = document.querySelector('.ripple');
//   $(ripple).remove();
//   ripple = document.createElement('span');
//   ripple.className = 'ripple';
//   ripple.style.height = ripple.style.width = Math.max(rect.width, rect.height) + 'px';
//   target.appendChild(ripple);
//   var top = e.pageY - rect.top - ripple.offsetHeight / 2 -  document.body.scrollTop;
//   var left = e.pageX - rect.left - ripple.offsetWidth / 2 - document.body.scrollLeft;
//   ripple.style.top = top + 'px';
//   ripple.style.left = left + 'px';
//   window.setTimeout(() => $(ripple).remove(), 750);
//   return false;
// });
// $(document).on('mouseleave', 'button.material, a.material, .button.material', function (e) {
//   var ripple: any = document.querySelector('.ripple');
//   $(ripple).remove();
// });

{ // global tooltip
  let $tooltip = null;
  let destroyTimer = null;

  const destroyTooltip = () => {
    destroyTimer = window.setTimeout(() => {
      if ($tooltip) $tooltip.remove();
      $tooltip = null;
    }, 500);
  };

  const cancelDestroy = () => {
    if (destroyTimer) window.clearTimeout(destroyTimer);
    destroyTimer = null;
  };

  const fixValueBetween = (minVal, val, maxVal) => {
    if (val < minVal) val = minVal;
    if (val > maxVal) val = maxVal;
    return val;
  };

  $(document).on('mouseenter', '[data-tooltip]', (event) => {
    let $el = $(event.target);
    if (!$el.data('tooltip')) $el = $el.parents('[data-tooltip]');
    if (!$el.data('tooltip')) return;
    cancelDestroy();

    const tooltip: string = String($el.data('tooltip'));
    let tooltipDirection: string = String($el.data('tooltip-direction'));

    $tooltip = $tooltip || $(`<div class="tooltip tooltip--global" style="position: absolute;  white-space: pre-wrap; overflow-wrap: break-word; padding:10px;  min-height: 30px;max-width: 100%; "></div>`);
    const bcr: ClientRect = $el[0].getBoundingClientRect();
    const ecx = (bcr.left + bcr.right) >> 1;
    const ecy = (bcr.top + bcr.bottom) >> 1;

    if (tooltipDirection === 'vertical') {
      if (bcr.top + bcr.height + 100 > document.body.offsetHeight) {          // 100 px approx for tooltip
        tooltipDirection = 'top';
      } else {
        tooltipDirection = 'bottom';
      }
    }

    let left: any,
      right: any,
      top: any,
      bottom: any,
      width = 180,
      transform: string,
      className: string = `tooltip--${tooltipDirection}`;

    const docWidth = $(document).width(), docHeight = $(document).height();
    switch (tooltipDirection) {
      case 'right':
        left = bcr.right;
        top = ecy;
        transform = 'translate(0, -50%)';
        break;
      case 'top':
        left = ecx;
        bottom = docHeight - bcr.top + 10;
        transform = 'translate(-50%, 0)';
        break;
      case 'left':
        right = docWidth - bcr.left + 20;
        top = ecy;
        transform = 'translate(0, -50%)';
        break;
      default:   // bottom
        left = ecx;
        top = bcr.bottom + 10;
        transform = 'translate(-50%, 0)';
        className = 'tooltip--bottom';
        break;
    }

    $tooltip.removeClass('top');
    $tooltip.removeClass('left');
    $tooltip.removeClass('right');
    $tooltip.removeClass('bottom');
    $tooltip.addClass(className);

    const tooltipCss = {
      'left': left != null ? fixValueBetween(5, left, docWidth - 50 - (width >> 2)) : 'auto',
      'top': top != null ? fixValueBetween(5, top, docHeight - 30) + 'px' : 'auto',
      'right': right != null ? fixValueBetween(5, right, docWidth - 5 - (width >> 2)) + 'px' : 'auto',
      'bottom': bottom != null ? fixValueBetween(5, bottom, docHeight - 30) + 'px' : 'auto',
      'width': width + 'px',
      'border': '1px solid #cccccc',
      'box-shadow': '0 0 10px rgba(0,0,0,0.5)',
      'z-index': 1001,
      'opacity': 1,
      'background': 'rgba(255,255,255, 0.9)',
      'border-radius': '2px',
      transform,
    };

    $tooltip.css(tooltipCss);
    $tooltip.text(tooltip);

    // if just created
    if (!$tooltip.parent()[0]) {
      $(document.body).append($tooltip);
    }
  });

  $(document).on('mouseleave', '[data-tooltip]', (event) => {
    destroyTooltip();
  });
} // global tooltip


AppConfig.getInstance().whenReady().then(init).catch((err) => {
  // Вероятно, файла settings.js нет, но все равно продолжим работать
  init();
});

// (app as any).title = AppConfig.getProjectTitle();

async function init() {
  const ShellVC = (await import('../src/view-controllers/ShellVC')).ShellVC;
  const Shell = (await import('../src/views/Shell')).Shell;
  const BIBoot = (await import('../src/views/BIBoot')).default;

  const root = ReactDOM.createRoot(document.getElementById('applicationHost'));

  function render(vmShell) {
    root.render(
      <BIBoot>
        {/*<LoadFromResources path="Shell.js" {...vmShell}>*/}
          <Shell {...vmShell}/>
        {/*</LoadFromResources>*/}
      </BIBoot>);
  }

  const shellVC = new ShellVC();
  shellVC.subscribeUpdatesAndNotify((vmShell) => {
    render(vmShell);
    // debug
    (window as any).__vm = vmShell;
  });

  $('#main-view-loading').remove();
}

if (module.hot) {
  module.hot.accept();
}
